export const ENTITY_TYPES = [
  "Sole Proprietorship",
  "Single-Member LLC",
  "Multi-Member LLC",
  "S-Corporation",
  "C-Corporation",
  "Partnership",
  "Nonprofit",
];

const LEGACY_ENTITY_TYPE_MAP = {
  "LLC": "Single-Member LLC",
  "S-Corp": "S-Corporation",
  "C-Corp": "C-Corporation",
};

export function normalizeEntityType(value) {
  const raw = (value || "").trim();
  if (!raw) return "";
  return LEGACY_ENTITY_TYPE_MAP[raw] || raw;
}

export function defaultEntityType(value = "") {
  const normalized = normalizeEntityType(value);
  return ENTITY_TYPES.includes(normalized) ? normalized : "Single-Member LLC";
}